import { EventMapper, GA4_EVENT_MAP } from '../eventMapper';
import { AnalyticsAdapter, AnalyticsConfig, AnalyticsEventParams, AnalyticsUser, XegueiEventName } from '../types';

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

/**
 * Adapter GA4 — carregamento dinâmico do gtag.js.
 * Suporte a SPA: cada navegação dispara page_view via track('PageView').
 */

export class GA4Adapter implements AnalyticsAdapter {
  public readonly name = 'ga4';
  private initialized = false;
  private measurementId?: string;

  isReady(): boolean {
    return this.initialized && typeof window !== 'undefined' && !!window.gtag;
  }

  async initialize(config: AnalyticsConfig): Promise<void> {
    if (this.initialized) return;
    if (!config.ga4MeasurementId) return;
    if (typeof window === 'undefined') return;

    this.measurementId = config.ga4MeasurementId;

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer!.push(arguments as any);
    };
    window.gtag('js', new Date());
    // SPA: desabilita page_view automático; controlamos manualmente.
    window.gtag('config', this.measurementId, { send_page_view: false });

    // Injeta script gtag.js
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(this.measurementId)}`;
    document.head.appendChild(s);

    this.initialized = true;
  }

  track(event: XegueiEventName, params: AnalyticsEventParams, _user?: AnalyticsUser): void {
    if (!this.isReady() || !this.measurementId) return;
    const ga4Name = GA4_EVENT_MAP[event] || event;
    const ga4Params = EventMapper.toGa4Params(params);
    if (params.eventId) ga4Params.event_id = params.eventId;
    try {
      window.gtag!('event', ga4Name, ga4Params);
    } catch (err) {
      console.warn('[GA4] event falhou', err);
    }
  }

  page(params?: AnalyticsEventParams): void {
    this.track('PageView', params || {});
  }
}
